var map = {
	"./bankbonus": [
		2960,
		9,
		960
	],
	"./bankbonus/": [
		2960,
		9,
		960
	],
	"./bankbonus/configs/base-config": [
		3610,
		9,
		610
	],
	"./bankbonus/configs/base-config.ts": [
		3610,
		9,
		610
	],
	"./bankbonus/configs/international-config": [
		2331,
		9,
		331
	],
	"./bankbonus/configs/international-config.ts": [
		2331,
		9,
		331
	],
	"./bankbonus/configs/italy-config": [
		9258,
		9,
		258
	],
	"./bankbonus/configs/italy-config.ts": [
		9258,
		9,
		258
	],
	"./bankbonus/configs/spain-config": [
		5300,
		9,
		300
	],
	"./bankbonus/configs/spain-config.ts": [
		5300,
		9,
		300
	],
	"./bankbonus/data-list": [
		7639,
		9,
		639
	],
	"./bankbonus/data-list.ts": [
		7639,
		9,
		639
	],
	"./bankbonus/index": [
		2960,
		9,
		960
	],
	"./bankbonus/index.ts": [
		2960,
		9,
		960
	],
	"./bankbonus/splash-icon.png": [
		3704,
		1,
		704
	],
	"./core/data-list": [
		2771,
		9
	],
	"./core/data-list.ts": [
		2771,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4195;
module.exports = webpackAsyncContext;